import React from 'react';

import { fetchQueryResultsFromURL } from '../api';

const Preview = ({ searchResults, setIsLoading, setSearchResults, setFeaturedResults, }) => {

  async function fetchPage(pageUrl) {
    setIsLoading(true);
    try {
      const results = await fetchQueryResultsFromURL(pageUrl);
      setSearchResults(results);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  return ( <aside id="preview">
    <header className="pagination">

      <button 
        disabled={ searchResults.info.prev ? false : true } 
        className="previous"
        onClick={_ => fetchPage(searchResults.info.prev)}>Previous
      </button>
    
      <button       
        disabled={ searchResults.info.next ? false : true }
        className="next"
        onClick={_ => fetchPage(searchResults.info.next)}>Next
      </button>
    </header>
    <section className="results">

      {
        searchResults.records.length ? 
        searchResults.records.map((record, idx) => {
          return (
            <div key={ idx}
            className="object-preview"
            onClick={ev => {
              ev.preventDefault()
              setFeaturedResults(record);
            }}> 
              <a href='#'>
                {
                  record.primaryimageurl ?
                    <img src={ record.primaryimageurl } alt={ record.description } />
                  : null
                }
                {
                  record.title ?
                    <h3>{ record.title }</h3>
                  : <h3>MISSING INFO</h3>
                }
              </a>
            </div>
          )
        })
        // end searchResults ternary
        : null
      }
        </section>
  </aside>
  )
}

export default Preview;